import type { TripStatus, VehicleType } from '@raahi/shared';
import { request } from './client.js';

export interface DriverStatusResult {
  id: string;
  status: 'offline' | 'online' | 'on_trip';
  lastSeen: string;
}

export function setStatus(status: 'online' | 'offline'): Promise<DriverStatusResult> {
  return request('/drivers/me/status', { method: 'PATCH', body: { status } });
}

export function pushLocation(lat: number, lng: number, heading?: number) {
  return request('/drivers/me/location', { method: 'POST', body: { lat, lng, heading } });
}

export interface EarningsSummary {
  today: number;
  week: number;
  lifetime: number;
  recent: Array<{
    id: string;
    fareTotal: number;
    endedAt: string | null;
    pickupLabel: string;
    dropLabel: string;
  }>;
}

export function getEarnings(): Promise<EarningsSummary> {
  return request('/drivers/me/earnings');
}

export interface DriverTripDto {
  id: string;
  status: TripStatus;
  vehicleType: VehicleType;
  pickup: { lat: number; lng: number; label: string };
  drop: { lat: number; lng: number; label: string };
  distanceKm: number;
  durationMin: number;
  fare: { base: number; distance: number; duration: number; surge: number; total: number };
  paymentMethod: string;
  driver?: { id: string };
}

export function getTrip(id: string): Promise<DriverTripDto> {
  return request<DriverTripDto>(`/trips/${id}`);
}

export function tripHistory(): Promise<DriverTripDto[]> {
  return request<DriverTripDto[]>('/trips/history');
}
